import { useWindowEvent } from '@utils/hooks/useWindowEvent'
import clsx from 'clsx'
import React, { createRef, ReactNode } from 'react'

type Prop = {
  children: ReactNode
  open: boolean
  onClose(): void
  direction?: 'left' | 'right'
}

const Drawer: React.FC<Prop> = ({ children, open, onClose, direction = 'left' }) => {
  const drawerRef = createRef<any>()

  useWindowEvent('mousedown', (event) => {
    if (!drawerRef.current?.contains(event.target)) {
      onClose()
    }
  })

  return (
    <div
      ref={drawerRef}
      className={clsx('fixed top-0 bottom-0 z-50 transform transition-transform', {
        'left-0': direction === 'left',
        'right-0': direction === 'right',
        'translate-x-0': open,
        '-translate-x-full': !open && direction === 'left',
        'translate-x-full': !open && direction === 'right',
      })}>
      {children}
    </div>
  )
}

export default Drawer
